import {renderStructuredElements} from "@/utils/render-helpers.jsx";
import SearchDropDown from "@/components/SearchDropDown";
document.addEventListener("DOMContentLoaded", () => {
  renderStructuredElements("search-dropdown", SearchDropDown);
});
